import React, { useEffect } from "react";

import classNames from "classnames";
import isUndefined from "lodash/isUndefined";
import PropTypes from "prop-types";
import { Draggable } from "react-beautiful-dnd";

import { Arrow } from "../../../Icon";

const parseTranslate = /translate\((.*?)px, (.*?)px\)/;

const DnDHeaderItem = ({ sortableColumns, setResizer, column, index }) => {
  // Sorts by sortDescFirst value on load if sortOnLoad is set to true
  useEffect(() => {
    sortableColumns.includes(column.id) &&
      !column.isSorted &&
      column.sortOnLoad &&
      !isUndefined(column.sortDescFirst) &&
      column.toggleSortBy(column.sortDescFirst, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Draggable
      key={column.id}
      draggableId={column.id}
      index={index}
      isDragDisabled={column.id === "selection"}
    >
      {(provided, snapshot) => {
        const headerProps = column.getHeaderProps();
        const resizerProps = {
          ...(column.getResizerProps && {
            ...column.getResizerProps(),
          }),
        };
        let transform = provided.draggableProps.style.transform;

        if (snapshot.isDragging && provided.draggableProps.style.transform) {
          const childValues = parseTranslate.exec(
            provided.draggableProps.style.transform
          );
          transform = `translate(${childValues[1]}px, 0px)`;
        }

        return (
          <th
            ref={provided.innerRef}
            {...headerProps}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...headerProps.style,
              ...provided.draggableProps.style,
              transform,
            }}
            className={classNames(
              snapshot.isDragging && "mydpd-dndtable-dragging-header-column"
            )}
          >
            <div className="d-flex align-items-center h-100">
              {column.render("Header")}
              {sortableColumns.includes(column.id) && (
                <span {...column.getSortByToggleProps()}>
                  <Arrow
                    className={classNames(
                      isUndefined(column.isSortedDesc) &&
                        "mydpd-dndtable-arrow-right",
                      !isUndefined(column.isSortedDesc) &&
                        !column.isSortedDesc &&
                        "mydpd-dndtable-arrow-up"
                    )}
                  />
                </span>
              )}
            </div>
            {column.getResizerProps && (
              <div
                {...column.getResizerProps()}
                className={classNames(
                  column.id !== "selection" && "mydpd-dndtable-column-resizer",
                  column.isResizing && "mydpd-dndtable-column-resizing"
                )}
                onMouseDown={e => {
                  setResizer(true);
                  resizerProps.onMouseDown(e);
                }}
              />
            )}
          </th>
        );
      }}
    </Draggable>
  );
};

DnDHeaderItem.propTypes = {
  sortableColumns: PropTypes.array,
  setResizer: PropTypes.func,
  column: PropTypes.object,
  index: PropTypes.number,
};

export default DnDHeaderItem;
